import React from 'react'

const Download = ({color}) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 36 36"
    enableBackground="new 0 0 36 36"
    xmlSpace="preserve"
  >
    <path
      fill={color}
      d="M23.4,12.6c0.8,0.1,1.5,0.3,2.2,0.6c0.7,0.3,1.3,0.8,1.8,1.3c0.5,0.5,0.9,1.2,1.2,1.8c0.3,0.7,0.4,1.4,0.4,2.2
      c0,0.7-0.1,1.5-0.4,2.2c-0.2,0.7-0.6,1.4-1.1,2c-0.5,0.6-1,1.1-1.7,1.5c-0.7,0.4-1.4,0.6-2.3,0.6c-0.2,0-0.4-0.1-0.5-0.2
      c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.2c0.6,0,1.1-0.1,1.6-0.4c0.5-0.3,0.9-0.7,1.2-1.2
      c0.3-0.5,0.6-1,0.8-1.6c0.2-0.6,0.3-1.2,0.3-1.8c0-0.6-0.1-1.2-0.4-1.8c-0.3-0.6-0.6-1.1-1.1-1.5c-0.4-0.4-1-0.8-1.5-1
      c-0.6-0.3-1.2-0.4-1.8-0.4l-0.5,0l-0.1-0.5c-0.4-1.1-0.9-2-1.7-2.7c-0.8-0.6-1.9-1-3.2-1c-0.9,0-1.6,0.1-2.3,0.4
      c-0.7,0.3-1.3,0.7-1.8,1.2c-0.5,0.5-0.9,1.2-1.1,1.9c-0.3,0.7-0.4,1.5-0.4,2.3h0l0,0.6l-0.6,0.1c-0.8,0.1-1.4,0.5-1.9,1.2
      c-0.5,0.7-0.8,1.5-0.8,2.3c0,1,0.3,1.8,1,2.5c0.7,0.7,1.4,1.1,2.3,1.1h0.6c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0c0,0.4-0.3,0.7-0.7,0.7
      c0,0,0,0,0,0h-0.6c-0.6,0-1.2-0.1-1.8-0.4c-0.6-0.3-1.1-0.6-1.5-1.1c-0.4-0.5-0.8-1-1-1.6C7.1,21.3,7,20.6,7,20c0-1.1,0.3-2.1,0.9-3
      s1.4-1.5,2.4-1.8c0.1-1,0.3-1.9,0.6-2.7c0.3-0.8,0.8-1.5,1.5-2.1C13,9.8,13.7,9.3,14.5,9c0.8-0.3,1.7-0.5,2.7-0.5
      c0.7,0,1.4,0.1,2.1,0.3c0.6,0.2,1.2,0.5,1.7,0.8c0.5,0.4,1,0.8,1.3,1.3C22.8,11.4,23.1,12,23.4,12.6L23.4,12.6z M20.9,23.7l0.2,0.1
      c0.1,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3l-2.5,2.8v0l-0.2,0.2c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1-0.1-0.2-0.1
      l-0.2-0.2v0L15,24.5c-0.1-0.1-0.2-0.2-0.1-0.4c0-0.1,0.1-0.3,0.1-0.4l0.2-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.3,0.1,0.4,0.2
      l1.5,1.6v-6.9c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v6.9l1.5-1.7
      c0.1-0.1,0.2-0.1,0.4-0.1S20.8,23.6,20.9,23.7L20.9,23.7z"
    />
  </svg>
)

export default Download
